import { z } from "zod";

export const UpdateMarketplaceListing$Params = z.object({
  artworkId: z.string(), // The artwork id to update listing for
  address: z.string(), // The user address in bech32
  utxosCBOR: z.string().array(), // The lust of CIP-30 fetched UTxOs
  noMintNew: z.number(), // How many to mint more?
  noFromWallet: z.number(), // How many to list from wallet?
  price: z.number(), // per edition
});
export type UpdateMarketplaceListing$Params = z.infer<
  typeof UpdateMarketplaceListing$Params
>;

export const UpdateMarketplaceListing$Result = z.object({
  tx: z.string(), // CBOR Hex
  protocolFee: z.number(),
  txFee: z.number(),
});
export type UpdateMarketplaceListing$Result = z.infer<
  typeof UpdateMarketplaceListing$Result
>;
